import { RootContainer } from '../../../../core/root_container';
import { ReviewJsEnv } from '../../models/review_js_env';
import { DeleteLinkContainer } from '../../../../core/views/pc/review/delete_link_container';
import { FeedbackContainer } from '../../../../core/views/pc/review/feedback_container';

export class ReviewContainer extends RootContainer<ReviewJsEnv> {
  constructor(model: ReviewJsEnv) {
    super();

    model.reviewJsOptions.forEach((opt) => {
      FeedbackContainer.init(opt.feedBackModel);
      DeleteLinkContainer.init(opt.deleteReviewModel);
    });

    // 初回描画
    this.update(model);
  }
}
